import React, { useEffect } from 'react';
import cx from 'classnames';

import { useTimer } from 'hooks/useTimer';

import styles from './timer.module.sass';

type PropTypes = {
  to: number;
  className?: string;
  handleTimerFinish?: () => void;
};

export const Timer: React.FC<PropTypes> = ({
  to,
  className,
  handleTimerFinish,
}) => {
  const { minutes, seconds, finished, addLeadingZeroIfOnCharNumber } = useTimer(
    { to }
  );

  useEffect(() => {
    if (finished && handleTimerFinish) {
      handleTimerFinish();
    }
  }, [finished, handleTimerFinish]);

  return (
    <span
      className={cx(styles.wrapper, { [styles.finished]: finished }, className)}
    >
      {addLeadingZeroIfOnCharNumber(minutes)}:
      {addLeadingZeroIfOnCharNumber(seconds)}
    </span>
  );
};
